import Lenis from 'lenis';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let lenisInstance = null;
let rafHandler = null;
let noScrollObserver = null;

function isTouchLikeDevice() {
    if (typeof window === 'undefined') return false;
    const hasTouchPoints = typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0;
    const coarsePointer = window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    return hasTouchPoints || coarsePointer;
}

function shouldUseNativeScroll() {
    if (typeof window === 'undefined') return true;
    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    return reducedMotion || isTouchLikeDevice();
}

function syncLenisWithNoScroll() {
    if (!lenisInstance) return;
    const hasNoScroll = document.body.classList.contains('no-scroll');
    if (hasNoScroll && typeof lenisInstance.stop === 'function') {
        lenisInstance.stop();
    } else if (!hasNoScroll && typeof lenisInstance.start === 'function') {
        lenisInstance.start();
    }
}

function observeNoScroll() {
    if (noScrollObserver) return;
    syncLenisWithNoScroll();
    noScrollObserver = new MutationObserver(syncLenisWithNoScroll);
    noScrollObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
    });
}

function initLenis() {
    if (shouldUseNativeScroll()) {
        destroyLenis();
        return null;
    }

    if (lenisInstance) {
        lenisInstance.resize();
        syncLenisWithNoScroll();
        return lenisInstance;
    }

    const lenis = new Lenis({
        autoRaf: false,
        lerp: 0.06,
        smoothWheel: true,
        smoothTouch: false,
        wheelMultiplier: 0.45,
        touchMultiplier: 1,
        anchors: true,
    });

    lenis.on('scroll', ScrollTrigger.update);

    rafHandler = (time) => {
        lenis.raf(time * 1000);
    };
    gsap.ticker.add(rafHandler);
    gsap.ticker.lagSmoothing(0);

    lenisInstance = lenis;
    window.__lenis = lenis;

    observeNoScroll();
    return lenisInstance;
}

function destroyLenis() {
    if (noScrollObserver) {
        noScrollObserver.disconnect();
        noScrollObserver = null;
    }
    if (!lenisInstance) return;
    lenisInstance.destroy();
    lenisInstance = null;
    if (window.__lenis) {
        delete window.__lenis;
    }
    if (rafHandler) {
        gsap.ticker.remove(rafHandler);
        rafHandler = null;
    }
}

export { initLenis, destroyLenis };
